import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '../../private/services/configuration.service';
import { authFlowLog } from '../services/auth-flow-log';
import { AuthStore } from '../stores/auth.store';
import { environment } from 'src/environments/environment';

export const sessionTenantGuard = (): boolean => {
  const authStore = inject(AuthStore);
  const configurationService = inject(ConfigurationService);
  const router = inject(Router);

  const sessionClub = authStore.club();
  const hostClub = configurationService.clientName;

  authFlowLog(environment.debug, '7-guard:session-tenant-check', {
    sessionClub,
    hostClub,
  });

  if (sessionClub !== null && sessionClub === hostClub) {
    return true;
  }

  void router.navigate(['/403']);
  return false;
};
